<div *ngIf="loading" class="loading-indicator">
    <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
</div>

<div *ngIf="isRestrictedSite && !isRefreshReq" style="padding-top: 10px !important; ">
    <h2 mat-dialog-title id="titleDialogRes">{{restrictedSite}}</h2>
    <div id="desc" class="primary-color"><b>{{siteData.sitename}}</b>{{siteNameDesc}}</div>
    <div style="margin-bottom:40px !important;">
        <ul *ngFor="let item of arr" style="padding-left: 16px !important; flex: 1;">
            <li class="primary-color">{{ item }}</li>
        </ul>
    </div>
     <div style="position: absolute; bottom: 0;right: 0;left: 0; padding-left: 20px; padding-right: 20px;"> 
        <div [innerHTML]="continueCancelDesc" class="primary-color"></div>
        <br>

        <div
            style="padding-right: 0px !important; border-top: none !important; padding-bottom: 15px !important; padding-top: 15px !important; float: right;">
            <button mat-raised-button (click)="cancel()" class="cancelBtn">{{cancelLabel}}</button>
            <button id="continueBtn" class="msTeam-btn" mat-raised-button style="margin-left:10px !important;"
                (click)="save()">{{continue}}</button>
        </div>
     </div> 
</div>
<div *ngIf="!isRestrictedSite" style="padding-top: 10px !important;">
    <h2 id="titleDialog" mat-dialog-title>{{alert}}</h2>
    <div><label id="refreshDesc" style="font-size: 16px; 
        font-weight: 500;" [innerHTML]="errorMsg" class="primary-color"></label></div>
    <br>
    <div style="width:100% !important; margin-top: 15px !important; " *ngIf="!isFullScreen">
        <button id="yesbtn" class="msTeam-btn" style="float: right !important; margin-bottom: 20px;"
            (click)="close()">{{ok}}</button>

        <button *ngIf=isNovisible class="cancelBtn" style="float: left !important; margin-bottom: 20px;"
            (click)="cancel()">No</button>
    </div>
    <div class="msTeam-modal-footerdialog add-divider"
      style="position: absolute; right: 0;left: 0; bottom: 0; margin-left: 20px; margin-right: 20px; margin-bottom: 6px;"
      *ngIf="isFullScreen">
      <button mat-raised-button (click)="cancel()" *ngIf="isNovisible" class="cancelBtn">No</button>
      <button id="yesbtn" class="msTeam-btn" mat-raised-button style="margin-left:10px;"
        (click)="close()">{{ok}}</button>
    </div>

</div>

<div *ngIf="isRefreshReq" class="nodata" style=" width: 100%; padding-left: 12px; padding-right: 12px; padding-bottom: 40px;" ><label id="refreshDesc" style="font-size: 16px;
    font-weight: 500;" [innerHTML]="errorMsg"></label></div>

<div *ngIf="isRefreshReq">
    <button id="yesbtn" class="msTeam-btn" style="position :absolute; bottom: 0; right: 0; margin-right: 16px; margin-bottom: 20px;"
    (click)="close()">{{ok}}</button>


</div>